module.exports = __webpack_public_path__ + "img/Content3.881b623c.png";